"use strict";

exports.__esModule = true;
exports.LoggerController = void 0;
var _react = require("react");
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var LoggerController = exports.LoggerController = /*#__PURE__*/function (_Component) {
  function LoggerController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      logError: function logError(error) {
        console.error(error);
      }
    };
    return _this;
  }
  _inheritsLoose(LoggerController, _Component);
  var _proto = LoggerController.prototype;
  _proto.render = function render() {
    return this.props.children(this.state);
  };
  return LoggerController;
}(_react.Component);